import { useRef } from 'react';
import * as R from 'remeda';
import { useIntl } from 'react-intl';
import { IconChevronRight } from '@rossum/ui/icons/tabler';
import { Skeleton, Stack, SvgIcon, Typography } from '@rossum/ui/material';
import { useWorkspacesWithQueues } from '../../queues/hooks/useWorkspacesWithQueues';

type Props = {
  activeQueueId: number | undefined;
  allDocumentsLevelIsActive?: boolean;
};

const BreadCrumbs = ({ activeQueueId, allDocumentsLevelIsActive }: Props) => {
  const intl = useIntl();

  const { allWorkspacesWithQueues, isLoading } = useWorkspacesWithQueues({
    enableQueries: true,
  });

  const currentWorkspace = allWorkspacesWithQueues?.find(ws =>
    ws.queues.some(q => q.id === activeQueueId)
  );
  const currentWorkspaceName = currentWorkspace?.name;
  const currentQueueName = currentWorkspace?.queues.find(
    q => q.id === activeQueueId
  )?.name;

  const skeletonQueueWidth = useRef(R.randomInteger(50, 100));
  const skeletonWorkspaceWidth = useRef(R.randomInteger(50, 100));

  if (!allDocumentsLevelIsActive && isLoading) {
    return (
      <Stack flexDirection="row" alignItems="center">
        <Skeleton variant="text" width={skeletonWorkspaceWidth.current} />
        <SvgIcon fontSize="medium" color="disabled" sx={{ mx: 1 }}>
          <IconChevronRight />
        </SvgIcon>
        <Skeleton variant="text" width={skeletonQueueWidth.current} />
      </Stack>
    );
  }

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        maxWidth: 0.5,
        minWidth: 50,
      }}
    >
      {allDocumentsLevelIsActive ? (
        <Typography
          variant="h5"
          sx={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
        >
          {intl.formatMessage({
            id: 'containers.settings.sidebar.allDocuments',
          })}
        </Typography>
      ) : (
        <>
          <Typography
            variant="h5"
            sx={{
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
          >
            {currentWorkspaceName}
          </Typography>
          <SvgIcon fontSize="medium" color="disabled" sx={{ mx: 1 }}>
            <IconChevronRight />
          </SvgIcon>
          <Typography
            variant="h5"
            sx={{
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
          >
            {currentQueueName}
          </Typography>
        </>
      )}
    </Stack>
  );
};

export { BreadCrumbs };
